"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfElectronicMedicalRecordSystemDto = instanceOfElectronicMedicalRecordSystemDto;
exports.ElectronicMedicalRecordSystemDtoFromJSON = ElectronicMedicalRecordSystemDtoFromJSON;
exports.ElectronicMedicalRecordSystemDtoFromJSONTyped = ElectronicMedicalRecordSystemDtoFromJSONTyped;
exports.ElectronicMedicalRecordSystemDtoToJSON = ElectronicMedicalRecordSystemDtoToJSON;
exports.ElectronicMedicalRecordSystemDtoToJSONTyped = ElectronicMedicalRecordSystemDtoToJSONTyped;
const ElectronicMedicalRecordSystem_1 = require("./ElectronicMedicalRecordSystem");
/**
 * Check if a given object implements the ElectronicMedicalRecordSystemDto interface.
 */
function instanceOfElectronicMedicalRecordSystemDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('otherDescription' in value) || value['otherDescription'] === undefined)
        return false;
    return true;
}
function ElectronicMedicalRecordSystemDtoFromJSON(json) {
    return ElectronicMedicalRecordSystemDtoFromJSONTyped(json, false);
}
function ElectronicMedicalRecordSystemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': (0, ElectronicMedicalRecordSystem_1.ElectronicMedicalRecordSystemFromJSON)(json['type']),
        'otherDescription': json['otherDescription'],
    };
}
function ElectronicMedicalRecordSystemDtoToJSON(json) {
    return ElectronicMedicalRecordSystemDtoToJSONTyped(json, false);
}
function ElectronicMedicalRecordSystemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': (0, ElectronicMedicalRecordSystem_1.ElectronicMedicalRecordSystemToJSON)(value['type']),
        'otherDescription': value['otherDescription'],
    };
}
//# sourceMappingURL=ElectronicMedicalRecordSystemDto.js.map